import React, { useCallback } from 'react';
import { Box, IconButton, Typography, withStyles } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { MTableToolbar } from '@material-table/core';
import useStyles from './style';
import AutoRefreshBar from './AutoRefreshBar';










const StyledMTableToolbar = withStyles(theme => ({
  root: {
    padding: theme.spacing(3, 0, 2.5, 2.5),
  },
  title: {
    '& > h6': {
      fontWeight: 'bold',
    },
  },
  searchField: {
    paddingRight: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
}))(MTableToolbar);

export default function TableToolbar(toolbarProps) {
  const {
    setSearch,
    hasFilters,
    selectedFiltersLength,
    toggleFilters,
    onRefresh,
    ...extraProps
  } = toolbarProps;

  const classes = useStyles();

  const onSearchChanged = useCallback(
    searchText => {
      toolbarProps.onSearchChanged(searchText);
      setSearch(searchText);
    },
    [toolbarProps, setSearch],
  );

  if (hasFilters) {
    return (
      React.createElement(React.Fragment, null
        , React.createElement(Box, { className: classes.toolbarContainer,}
          , React.createElement(Box, { className: classes.toolbarContainer,}
            , React.createElement(IconButton, {
              onClick: toggleFilters,
              'aria-label': "filter list" ,
              className: classes.toolbarIcon,}
            
              , React.createElement(FilterListIcon, null )
            )
            , React.createElement(Typography, { className: classes.toolbarTitle,}, "Filters ("
               , selectedFiltersLength, ")"
            )
          )
          , React.createElement(StyledMTableToolbar, {
            ...extraProps,
            onSearchChanged: onSearchChanged,}
          )
        )
        , onRefresh && React.createElement(AutoRefreshBar, { onRefresh: onRefresh,} )
      )
    );
  }

  return (
    React.createElement(React.Fragment, null
      , React.createElement(StyledMTableToolbar, { ...extraProps, onSearchChanged: onSearchChanged,} )
      , onRefresh && React.createElement(AutoRefreshBar, { onRefresh: onRefresh,} )
    )
  );
}
